@switch (props.pickState) {
    @case (oddsStateType.Open) {
        <div class="betslip-over-ask-price-changes">
            @switch (isSingleBet) {
                @case (true) {
                    <div
                        class="betslip-over-ask-price-changes__single"
                        [ngClass]="{
                            'betslip-over-ask-price-changes__single--price-change': !!pickOverridenPrice,
                            'betslip-over-ask-price-changes__single--stake-change': !!singleBetOverridenStake,
                        }">
                        <div class="betslip-over-ask-pick__changes__odds">
                            <div class="betslip-over-ask-pick__changes--old">
                                @if (!!pickOverridenPrice) {
                                    <span>{{ formatPrice(pickInitialPrice) }}</span>
                                }
                            </div>
                            <div class="betslip-over-ask-pick__changes--new">
                                <!--When we have overriden price we show it, when not we show initial price -->
                                @if (!!pickOverridenPrice) {
                                    <span>{{ formatPrice(pickOverridenPrice) }}</span>
                                }
                                @if (!pickOverridenPrice) {
                                    <span>{{ formatPrice(pickInitialPrice) }}</span>
                                }
                            </div>
                        </div>
                        <div class=".betslip-over-ask-pick__changes__stake">
                            <div class="betslip-over-ask-pick__changes--old">
                                @if (singleBetOverridenStake || hasEachWayChange) {
                                    <span>
                                        @if (isInitialEachWay) {
                                            2 x
                                        }
                                        {{ singleBetStake | bsCurrency }}</span
                                    >
                                }
                            </div>
                            <div class="betslip-over-ask-pick__changes--new">
                                @if (!singleBetOverridenStake) {
                                    <span>
                                        @if ((!hasEachWayChange && isInitialEachWay) || isCounterOfferEachWay) {
                                            2 x
                                        }
                                        {{ singleBetStake | bsCurrency: true }}</span
                                    >
                                }
                                @if (!!singleBetOverridenStake) {
                                    <span>
                                        @if ((!hasEachWayChange && isInitialEachWay) || isCounterOfferEachWay) {
                                            2 x
                                        }
                                        {{ singleBetOverridenStake | bsCurrency: true }}</span
                                    >
                                }
                            </div>
                        </div>
                    </div>
                }
                @case (false) {
                    <div
                        class="betslip-over-ask-price-changes__combo"
                        [class.betslip-over-ask-price-changes__combo--price-change]="!!pickOverridenPrice">
                        <div class="betslip-over-ask-pick__changes__odds">
                            <div class="betslip-over-ask-pick__changes--old">
                                @if (!!pickOverridenPrice) {
                                    <span>{{ formatPrice(pickInitialPrice) }}</span>
                                }
                            </div>
                            <div class="betslip-over-ask-pick__changes--new">
                                @if (!!pickOverridenPrice) {
                                    <span>{{ formatPrice(pickOverridenPrice) }}</span>
                                }
                                @if (!pickOverridenPrice) {
                                    <span>{{ formatPrice(pickInitialPrice) }}</span>
                                }
                            </div>
                        </div>
                    </div>
                }
            }
        </div>
    }
    @case (oddsStateType.Locked) {
        <span class="betslip-over-ask-pick-odds__value--locked theme-locked-i"></span>
    }
    @case (oddsStateType.Closed) {
        <span class="betslip-over-ask-pick-odds__value--closed">{{ messages.closed }}</span>
    }
}
